var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-filetype-tiff",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    id: "svg_1",
    d: "m14.25,4.75l0,9.5a2,2 0 0 1 -2,2l-1,0l0,-1l1,0a1,1 0 0 0 1,-1l0,-9.5l-2,0a1.5,1.5 0 0 1 -1.5,-1.5l0,-2l-5.5,0a1,1 0 0 0 -1,1l0,9l-1,0l0,-9a2,2 0 0 1 2,-2l5.5,0l4.5,4.5zm-12.072,8.012l0,3.337l-0.794,0l0,-3.337l-1.134,0l0,-0.662l3.064,0l0,0.662l-1.136,0zm2.131,-0.662l0,3.999l-0.79,0l0,-3.999l0.79,0zm1.373,3.999l0,-1.59l1.606,0l0,-0.64l-1.606,0l0,-1.116l1.758,0l0,-0.653l-2.549,0l0,3.999l0.791,0zm2.868,-1.59l0,1.59l-0.791,0l0,-3.999l2.548,0l0,0.653l-1.757,0l0,1.117l1.605,0l0,0.638l-1.605,0l0,0.001z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/tiff.779b5336f815adfab08b922e78b0cff7.svg";
export { ForwardRef as ReactComponent };